import { render, staticRenderFns } from "./PasswordAndConfirmFields.vue?vue&type=template&id=2d4400cb"
import script from "./PasswordAndConfirmFields.vue?vue&type=script&lang=js"
export * from "./PasswordAndConfirmFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports